import {DEFAULT_PROJECT_NAME} from '../../../agentChat/runtime/backend';
import type {ThreadSummary} from '../../../agentChat/store/thread';

/**
 * getProjectChipLabel returns the chip label for a history row, or null
 * when no chip should be shown (no relevant project, or the project is the
 * backend default). Renders the first non-default project; format is
 * `project` when the row's entity matches the current entity, else
 * `entity/project`.
 */
export function getProjectChipLabel(
  thread: Pick<ThreadSummary, 'projects'>,
  currentEntity: string | null
): string | null {
  const project = thread.projects.find(
    p => p.projectName && p.projectName !== DEFAULT_PROJECT_NAME
  );
  if (!project) {
    return null;
  }

  return currentEntity && project.entityName === currentEntity
    ? project.projectName
    : `${project.entityName}/${project.projectName}`;
}
